import { t } from 'i18next/dist/commonjs';
import React from 'react';

import { Row, Col, Button, Form } from 'react-bootstrap';
import { translate } from "react-i18next";


class FileUpload extends React.Component {

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this)
        this.removeFile = this.removeFile.bind(this)

        this.state = {
            file: null
        }
    }


    onChange(e) {
        console.log("e.target.files[0] " + JSON.stringify(e.target.files[0]))
        this.props.fileChanged(e.target.files[0]);
        let oldState = this.state;
        this.setState({
            ...oldState,
            file: e.target.files[0]
        })
    }


    removeFile() {
        this.props.fileChanged(null);
        let oldState = this.state;
        this.setState({
            ...oldState,
            file: null
        })
    }


    render() {
        const { t } = this.props;
        return (
            <form >
                <Row className="pt-2 pb-2">
                    <Col > 
                    <Form.Label for="fileUpload" class="btn btn-primary  btn-outlined">{t("uploadFile")}</Form.Label>
                    <input type="file" onChange={this.onChange} id="fileUpload" style={{"display":"none"}} /></Col>
                    {this.state.file ?
                        <Col> <img src={URL.createObjectURL(this.state.file)} style={{ "maxWidth": "200px", "maxHeight": "200px" }} /></Col>
                        :
                        ''
                    }
                    {this.state.file && this.props.showRemove ?
                        <Col>  <Button variant="outline-primary" onClick={this.removeFile} className="float-left ml-3 mt-2"><span className="fa fa-trash-alt ">{t("removeImage")}</span></Button>
                        </Col>
                        :
                        ''}
                </Row>

            </form>
        )
    }
}

export default translate("translations")(FileUpload);
